var styleDataHash = "0609d955";
const injectCss = (() => {
  var css = `._9qvOL{margin-left:0;margin-right:auto;z-index:1}._9qvOL:not(.igFNj){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){._9qvOL:not(.igFNj){float:none;margin-right:auto}}}@container (width < 480px){._9qvOL:not(.igFNj){float:none;margin-right:auto}}.ZZmIB{margin-left:auto;margin-right:0;z-index:1}.ZZmIB:not(.igFNj){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.ZZmIB:not(.igFNj){float:none;margin-left:auto}}}@container (width < 480px){.ZZmIB:not(.igFNj){float:none;margin-left:auto}}.Pg932{clear:both;display:block}.Pg932:not(._9kDoU){margin-left:auto;margin-right:auto;max-width:100%}._9kDoU,.igFNj{width:100%}.ozoU5 ._9kDoU,.ozoU5 .igFNj{margin:0 -8px;width:auto}._9d7zq{width:fit-content}.Vy-B-{margin-left:auto;margin-right:auto;max-width:100%}._2X-Kp{width:min(350px,100%)!important}.ozoU5 ._2X-Kp{width:50%}._3VEbe{margin-left:auto;margin-right:auto}.ozoU5 ._3VEbe{width:150px}.Q464U{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "alignLeft": "_9qvOL",
  "textWrapNowrap": "igFNj",
  "alignRight": "ZZmIB",
  "alignCenter": "Pg932",
  "sizeFullWidth": "_9kDoU",
  "renderedInTable": "ozoU5",
  "sizeOriginal": "_9d7zq",
  "sizeContent": "Vy-B-",
  "sizeSmall": "_2X-Kp",
  "sizeSmallCenter": "_3VEbe",
  "flex": "Q464U"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
